module.exports = __webpack_public_path__ + "img/csvIcon.eca9ecd.svg";